// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Vip29LiffNavbar_wrapper__Q6eRz","logoWrapper":"Vip29LiffNavbar_logoWrapper__I9cib","logo":"Vip29LiffNavbar_logo__6VGsf"};